import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "tiktok"
const TiktokIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.404 3C14.406 3.007 13.408 3 12.404 3.015 12.38 6.03 12.395 9.045 12.387 12.067 12.38 13.41 12.41 14.745 12.334 16.087 12.326 16.38 12.165 16.635 12.02 16.882 11.575 17.595 10.753 18.082 9.894 18.09 8.604 18.202 7.392 17.167 7.208 15.937 7.201 15.532 7.155 15.112 7.316 14.73 7.507 14.197 7.876 13.725 8.359 13.417 9.027 12.967 9.917 12.9 10.677 13.14 10.677 12.03 10.723 10.92 10.707 9.81 9.042 9.502 7.262 10.02 5.988 11.1 4.868 12.03 4.146 13.395 4.008 14.82 3.993 15.187 4.001 15.562 4.016 15.937 4.177 17.692 5.266 19.327 6.816 20.22 7.754 20.76 8.85 21.052 9.949 20.992 11.736 20.962 13.478 20.025 14.483 18.585 15.104 17.722 15.457 16.68 15.519 15.63 15.542 13.447 15.526 11.257 15.534 9.067 15.933 9.322 16.34 9.57 16.777 9.765 17.782 10.23 18.895 10.455 20 10.492V7.47C18.818 7.342 17.606 6.96 16.746 6.127 15.887 5.317 15.465 4.147 15.404 3" />
        </svg>
      }
    </span>
  )
}
export default TiktokIcon
